import { getNearbyShipmentOptionsArgsToParams } from 'data/api/transformers/arguments/get-nearby-shipment-options-args-to-params'
import { GetNearbyShippingOptionsArgs } from 'types/api/arguments/get-nearby-shipping-options-args'
import { NearbyShippingOptionsResp } from 'types/api/response/nearby-shipping-options-resp'

import { api } from './api'
import { moneyObjectHeader } from './money-object-header'

export const getNearbyShippingOptions = (args: GetNearbyShippingOptionsArgs) =>
  api.get<NearbyShippingOptionsResp>(
    `/transactions/${args.transactionId}/nearby_shipping_options`,
    {
      params: getNearbyShipmentOptionsArgsToParams(args),
      headers: moneyObjectHeader,
    },
  )
